(function() {
  window.frameService = {
    get() {
      return axios.get(`/api/frame/get.php`);
    },
    save(data) {
      return axios.post('/api/frame/save.php', data);
    },
    delete(id) {
      return axios.delete('/api/frame/delete.php', {
        data: { id },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    upload(frameId, file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('id', frameId);

      return axios.post('/api/frame/upload.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    getUserFrames(userId) {
      return axios.get(`/api/frame/user.php?userId=${userId}`);
    }
  }
})();